/*
This file was created by the script build.py 
*/

import {buttonOnClick, checkAllButtons, callAllCategories} from "./globalFilterUI"
import {allCheckboxesState} from "./checkboxState"

// show or hide buttons
$(document).ready(function(){
    $("#iconFurtherSearchCategorisation").click(function(){
        var buttons = document.getElementById("buttonWrapperFurtherSearchCategorisation")
        const iconId = "#"+$(this).attr('id');
        if(buttons.classList.contains("show")){
            $(buttons).hide()
            buttons.classList.remove("show")
            $(iconId).toggleClass("bi bi-caret-up-fill", false)
            $(iconId).toggleClass("bi bi-caret-down-fill", true)
        }
        else{
            $(buttons).show()
            buttons.classList.add("show")
            $(iconId).toggleClass("bi bi-caret-down-fill", false)
            $(iconId).toggleClass("bi bi-caret-up-fill", true)
        }
    })
})

//checkbox Further Search Categorisation
document.getElementById("categoryFurtherSearchCategorisation").onclick=function(){
    const checkboxId = $(this).attr('id')
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    if(allCheckboxesState[checkboxId].checked){
        checkbox.checked = true
    }
    else if(allCheckboxesState[checkboxId].indeterminate){
        checkbox.indeterminate = true
    }
    else{
        checkbox.checked = false
    }
    
    const iconId = "#iconFurtherSearchCategorisation";
    var buttons = document.getElementById("buttonWrapperFurtherSearchCategorisation")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    allCheckboxesState[checkboxId].checked = checkbox.checked

}

//Name Further Search Categorisation
document.getElementById("furtherSearchCategorisationLabel").onclick=function(){
    const iconId = "#iconFurtherSearchCategorisation";
    var buttons = document.getElementById("buttonWrapperFurtherSearchCategorisation")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    
}

//Button: "select all buttons"
document.getElementById("buttonFurtherSearchCategorisationSelectAll").onclick=function(){
    const checkboxId = "categoryFurtherSearchCategorisation"
    var checkbox = document.getElementById(checkboxId)
    checkbox.indeterminate = false
    checkbox.checked = true
    allCheckboxesState[checkboxId].checked = checkbox.checked
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

//Button: "select none buttons"
document.getElementById("buttonFurtherSearchCategorisationSelectNone").onclick=function(){
    const checkboxId = "categoryFurtherSearchCategorisation"
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    checkbox.indeterminate = false
    allCheckboxesState[checkboxId].checked = checkbox.checked
    allCheckboxesState[checkboxId].indeterminate = checkbox.indeterminate
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

// any-Button Further Search Categorisation
document.getElementById("buttonFurtherSearchCategorisationAny").onclick = function(){
    var buttonAny = document.getElementById("buttonFurtherSearchCategorisationAny")
    var buttonAll = document.getElementById("buttonFurtherSearchCategorisationAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}

// all-Button Further Search Categorisation
document.getElementById("buttonFurtherSearchCategorisationAll").onclick = function(){
    var buttonAny = document.getElementById("buttonFurtherSearchCategorisationAny")
    var buttonAll = document.getElementById("buttonFurtherSearchCategorisationAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}


//Button AdditionalHiggsbosons in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationAdditionalHiggsbosons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Compositeness in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationCompositeness").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button ContactInteractions in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationContactInteractions").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button DarkMatterDarksector in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationDarkMatterDarksector").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Excitedfermions in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationExcitedfermions").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button ExtraDimensions in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationExtraDimensions").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Heavyadditionalfermions in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationHeavyadditionalfermions").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Leptonflavourviolation in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationLeptonflavourviolation").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Leptoquarks in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationLeptoquarks").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button LongLivedparticles in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationLongLivedparticles").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button NewResonances in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationNewResonances").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Supersymmetry in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetry").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetryCharginosNeutralinosWinosHiggsinos in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetryCharginosNeutralinosWinosHiggsinos").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetryGMSB in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetryGMSB").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetryRPV in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetryRPV").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetrySleptons in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetrySleptons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetrySquarksandgluinos in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetrySquarksandgluinos").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SupersymmetryStopsandsbottoms in Further Search Categorisation change color on click Event
document.getElementById("buttonFurtherSearchCategorisationSupersymmetryStopsandsbottoms").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

